import { Button, Typography } from "antd";
import { SvgIcon } from "assets/icons";
import CustomModal from "components/CustomModal";
import { useConfirmSavedDocumentPurchaseOrder } from "hooks/purchase";
import { t } from "i18next";
import { useState } from "react";
import { notify } from "utils/helperFuncs";
import "./index.scss";

export const ButtonUpVoucher = ({ record }) => {
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };
  const handleCancel = () => {
    setVisible(false);
  };

  const { handleConfirmSavedDocumentPurchaseOrder, loading } = useConfirmSavedDocumentPurchaseOrder();

  const onConfirm = async () => {
    try {
      await handleConfirmSavedDocumentPurchaseOrder([record?.id])
        .then(() => {
          setVisible(false);
          notify.success({
            message: t("purchase.buttonGroup.confirmSavedDocumentSuccess"),
          });
        })
        .catch((error) => {
          notify.error({
            message: error.message,
          });
        });
    } catch (error) {
      notify.error({
        message: error.message,
      });
    }
  };

  return (
    <div>
      <CustomModal
        {...{
          width: "30%",
          customComponent: (
            <Button type="secondary" loading={loading}>
              {t("purchase.buttonGroup.savedDocument")}
            </Button>
          ),
          footer: false,
          centered: true,
          styleButton: "notButton",
          hideConfirmButton: true,
          className: "form-saved-document-purchase-order",
          addMoreButton: (
            <div className="button-group-action-saved-document-purchase-order">
              <Button type="secondary" htmlType="submit" onClick={handleCancel} loading={loading}>
                {t("productBrand.cancel")}
              </Button>
              <Button type="primary" htmlType="submit" onClick={onConfirm} loading={loading}>
                {t("common.confirm")}
              </Button>
            </div>
          ),
          visible: visible,
          onOpen: showModal,
          onCancel: handleCancel,
          hideCancelButton: true,
        }}
      >
        <div className="form-saved-document-content">
          <SvgIcon.IconInfoConfirm />
          <div>
            <Typography.Text>{t("purchase.buttonGroup.confirmSavedDocument")}</Typography.Text>
          </div>
        </div>
      </CustomModal>
    </div>
  );
};
